import http from '@/services/http';

const monitoringApi = {
  pendingAcceptance(params = {}, config = {}) {
    return http.request({
      method: 'get',
      url: '/monitoring/pending-acceptance',
      params,
      ...config,
    });
  },

  expired(params = {}, config = {}) {
    return http.request({
      method: 'get',
      url: '/monitoring/expired',
      params,
      ...config,
    });
  },

  closingDue(params = {}, config = {}) {
    return http.request({
      method: 'get',
      url: '/monitoring/closing-due',
      params,
      ...config,
    });
  },

  awaitingProcessing(params = {}, config = {}) {
    return http.request({
      method: 'get',
      url: '/monitoring/awaiting-processing',
      params,
      ...config,
    });
  },

  awaitingProcessingDetail(params = {}, config = {}) {
    return http.request({
      method: 'get',
      url: '/monitoring/awaiting-processing/details',
      params,
      ...config,
    });
  },

  awaitingProcessingDetailCount(params = {}, config = {}) {
    return http.request({
      method: 'get',
      url: '/monitoring/awaiting-processing/details/count',
      params,
      ...config,
    });
  },

  awaitingProcessingSampleAnalyses(labSampleId, params = {}, config = {}) {
    return http.request({
      method: 'get',
      url: `/monitoring/awaiting-processing/details/${labSampleId}/analyses`,
      params,
      ...config,
    });
  },

  pendingAcceptanceDetail(params = {}, config = {}) {
    return http.request({
      method: 'get',
      url: '/monitoring/pending-acceptance/details',
      params,
      ...config,
    });
  },

  pendingAcceptanceDetailCount(params = {}, config = {}) {
    return http.request({
      method: 'get',
      url: '/monitoring/pending-acceptance/details/count',
      params,
      ...config,
    });
  },

  pendingAcceptanceOrderSamples(orderId, params = {}, config = {}) {
    return http.request({
      method: 'get',
      url: `/monitoring/pending-acceptance/details/${orderId}/samples`,
      params,
      ...config,
    });
  },

  toCompleteSummary(params = {}, config = {}) {
    return http.request({
      method: 'get',
      url: '/monitoring/to-complete/summary',
      params,
      ...config,
    });
  },

  toComplete(params = {}, config = {}) {
    return http.request({
      method: 'get',
      url: '/monitoring/to-complete',
      params,
      ...config,
    });
  },

  toCompleteCount(params = {}, config = {}) {
    return http.request({
      method: 'get',
      url: '/monitoring/to-complete/count',
      params,
      ...config,
    });
  },

  // the cell edit sends a single id,
  // the bulk dialog the whole selection. `note: ''` is the deletion.
  toCompleteSaveNotes(data = {}, config = {}) {
    return http.request({
      method: 'put',
      url: '/monitoring/to-complete/notes',
      data,
      ...config,
    });
  },

  toCompleteExport(params = {}, config = {}) {
    return http.request({
      method: 'get',
      url: '/monitoring/to-complete/export',
      params,
      responseType: 'blob',
      ...config,
    });
  },

  exportDetails(params = {}, config = {}) {
    return http.request({
      method: 'get',
      url: '/monitoring/details/export',
      params,
      responseType: 'blob',
      ...config,
    });
  },
};

export default monitoringApi;
